module.exports = __webpack_public_path__ + "img/4f_r_jindaiji.d2df1d6f.png";